module.exports = __webpack_public_path__ + "img/SKMJ_heavy2.3479fc0f.png";